"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = void 0;
exports.i18n = {
    account: 'Account Settings',
    activity: 'Activity',
    guest: 'Guest',
    download: 'Download',
    marketplaceAuthorizations: 'Marketplace Authorizations',
    myAssets: 'My Assets',
    myLists: 'My Lists',
    profile: 'Profile',
    signIn: 'Sign In',
    signOut: 'Log Out',
    viewProfile: 'View Profile'
};
